import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import GridOptionsButton from "../../../../../common/GridOptionsButton";
import axios from "axios";
import routes from "../../../../../assets/apiRoutes.json";
import notify from "devextreme/ui/notify";
import { alert } from "devextreme/ui/dialog";
import { OrderDetailGridOptions } from "../../../../../enum/Enum";
import { MESSAGES } from "../../../../../common/Messages";
import { getApiErrorMessage } from "../../../../../common/concurrency";

const operationDropDownItems = [
    { id: OrderDetailGridOptions.ReviewedInventoryId, name: OrderDetailGridOptions.ReviewedInventoryDescription },
];

/**
 * Shared Order Detail bottom grid. Legacy uOMD0013 mgtTopTabChange only sets
 * `opReviewedInventory.Visible := True` under the Sales Orders top tab and explicitly hides it on
 * Historical Orders, All Orders, Customers, Item Master, Item Lot and EDI Web — so the Options
 * button is opt-in via `allowReviewedInventory` rather than always on.
 */

const OrderDetailResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "374891c2-66e4-4651-b0c7-198c076020bc";
       const [currentLayout, setCurrentLayout]= useState("Default");
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const [selectedDetailRow, setSelectedDetailRow] = useState(null);
    const [running, setRunning] = useState(false);

    const onSelectionChanged = ({ selectedRowsData }) => {
        const rows = selectedRowsData || [];
        setSelectedDetailRow(rows.length === 1 ? rows[0] : null);
    };

    /** Delphi opReviewedInventoryClick — marks the selected detail line reviewed ('Y' -> 'R');
     *  the header review flag is cleared server-side once no pending lines remain. */
    const handleReviewedInventory = useCallback(async () => {
        const detailRowId = selectedDetailRow?.rowid;
        if (!detailRowId) {
            alert(MESSAGES.SELECT_DETAIL_LINE, OrderDetailGridOptions.ReviewedInventoryDescription);
            return;
        }
        setRunning(true);
        try {
            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.OM.ReviewedInventory}`,
                { Rowid: detailRowId, RTransactionheader: selectedDetailRow?.rTransactionheader },
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            if (res.data?.success === false) {
                alert(getApiErrorMessage(res.data, MESSAGES.INVENTORY_REVIEW_ERROR), OrderDetailGridOptions.ReviewedInventoryDescription);
                return;
            }
            // Use the client constant, not res.data.message: the All-Items entry point goes through
            // runHeaderOperation, which ignores the server message, so this keeps both toasts identical.
            notify({ message: MESSAGES.INVENTORY_REVIEW_COMPLETED, width: 260 }, "success", 3000);
            dataGrid.current.instance().refresh();
            if (props.onHeaderRefresh) {
                props.onHeaderRefresh();
            }
        } catch (err) {
            // No CONCURRENCY_HANDLED branch here on purpose: ReviewedInventoryAsync updates in bulk
            // via ExecuteUpdateAsync, so it never validates a token and can never return 409.
            alert(getApiErrorMessage(err, MESSAGES.INVENTORY_REVIEW_ERROR), OrderDetailGridOptions.ReviewedInventoryDescription);
        } finally {
            setRunning(false);
        }
    }, [selectedDetailRow, accessToken, props.onHeaderRefresh]);

    const onOperationItemClick = (e) => {
        if (e.itemData?.id === OrderDetailGridOptions.ReviewedInventoryId) {
            handleReviewedInventory();
        }
    };

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling mode="standard" />
                <Column dataField="warehouseID" caption='WH' ></Column>
                <Column dataField="itemCode" caption='Item' ></Column>
                <Column dataField="itemDesc1" caption='Item Description- 1' ></Column>
                <Column dataField="lotCode" caption='Lot' ></Column>
                <Column dataField="quantityordered" format={{
                    type: 'fixedPoint',
                    precision: 2
                }} caption='Ordered' ></Column>
                <Column dataField="quantityshipped" format={{
                    type: 'fixedPoint',
                    precision: 2
                }} caption='Shipped' ></Column>
                <Column dataField="unitPrice" format={{
                    type: 'currency',
                    precision: 2
                }} caption='UnitPrice' ></Column>
                <Column dataField="amount" format={{
                    type: 'currency',
                    precision: 2
                }} caption='Amount' ></Column>
                <Column dataField="lotPctOversoldCurrently" format={{
                    type: 'fixedPoint',
                    precision: 2
                }} caption='Lot Pct Oversold Currently' ></Column>
                <Column dataField="discountPercent" visible={false} format={{
                    type: 'fixedPoint',
                    precision: 2
                }} caption="Discount Percent"></Column>
                <Column dataField="unitOfMeasure" visible={false} caption="Unit Of Measure"></Column>
                <Column dataField="referenceNumber" visible={false} caption="Reference Number"></Column>
                <Column dataField="comment" visible={false} caption="Comment"></Column>
                <Column dataField="userDefinedComment" visible={false} caption="User Defined Comment"></Column>
                <Column dataField="quantityBackOrder" visible={false} format={{
                    type: 'fixedPoint',
                    precision: 2
                }} caption="Quantity Back Order"></Column>
                <Column dataField="originalQuantityOrdered" visible={false} format={{
                    type: 'fixedPoint',
                    precision: 2
                }} caption="Original Quantity Ordered"></Column>
                <Column dataField="cogsAmount" visible={false} caption="COGS Amount"></Column>
                <Column dataField="omDetailCode1" visible={false} caption="Code-1 OMDetail"></Column>
                <Column dataField="omDetailCode2" visible={false} caption="Code-2 OMDetail"></Column>
                <Column dataField="omDetailCode3" visible={false} caption="Code-3 OMDetail"></Column>
                <Column dataField="omDetailCode4" visible={false} caption="Code-4 OMDetail"></Column>
                <Column dataField="omDetailCode5" visible={false} caption="Code-5 OMDetail"></Column>
                <Column dataField="omDetailCode6" visible={false} caption="Code-6 OMDetail"></Column>
                <Column dataField="omDetailCode7" visible={false} caption="Code-7 OMDetail"></Column>
                <Column dataField="omDetailCode8" visible={false} caption="Code-8 OMDetail"></Column>
                <Column dataField="omDetailCode9" visible={false} caption="Code-9 OMDetail"></Column>
                <Column dataField="omDetailCode10" visible={false} caption="Code-10 OMDetail"></Column>
                <Column dataField="omDetailDate1" visible={false} dataType="date" format="MM/dd/yyyy" caption="Date-1 OMDetail"></Column>
                <Column dataField="omDetailDate2" visible={false} dataType="date" format="MM/dd/yyyy" caption="Date-2 OMDetail"></Column>
                <Column dataField="omDetailDate3" visible={false} dataType="date" format="MM/dd/yyyy" caption="Date-3 OMDetail"></Column>
                <Column dataField="omDetailDate4" visible={false} dataType="date" format="MM/dd/yyyy" caption="Date-4 OMDetail"></Column>
                <Column dataField="omDetailDate5" visible={false} dataType="date" format="MM/dd/yyyy" caption="Date-5 OMDetail"></Column>
                <Column dataField="omDetailDate6" visible={false} dataType="date" format="MM/dd/yyyy" caption="Date-6 OMDetail"></Column>
                <Column dataField="omDetailDate7" visible={false} dataType="date" format="MM/dd/yyyy" caption="Date-7 OMDetail"></Column>
                <Column dataField="omDetailDate8" visible={false} dataType="date" format="MM/dd/yyyy" caption="Date-8 OMDetail"></Column>
                <Column dataField="omDetailDate9" visible={false} dataType="date" format="MM/dd/yyyy" caption="Date-9 OMDetail"></Column>
                <Column dataField="omDetailDate10" visible={false} dataType="date" format="MM/dd/yyyy" caption="Date-10 OMDetail"></Column>
                <Column dataField="omDetailQuantity1" visible={false} caption="Quantity-1 OMDetail"></Column>
                <Column dataField="omDetailQuantity2" visible={false} caption="Quantity-2 OMDetail"></Column>
                <Column dataField="omDetailQuantity3" visible={false} caption="Quantity-3 OMDetail"></Column>
                <Column dataField="omDetailQuantity4" visible={false} caption="Quantity-4 OMDetail"></Column>
                <Column dataField="omDetailQuantity5" visible={false} caption="Quantity-5 OMDetail"></Column>
                <Column dataField="omDetailQuantity6" visible={false} caption="Quantity-6 OMDetail"></Column>
                <Column dataField="omDetailQuantity7" visible={false} caption="Quantity-7 OMDetail"></Column>
                <Column dataField="omDetailQuantity8" visible={false} caption="Quantity-8 OMDetail"></Column>
                <Column dataField="omDetailQuantity9" visible={false} caption="Quantity-9 OMDetail"></Column>
                <Column dataField="omDetailQuantity10" visible={false} caption="Quantity-10 OMDetail"></Column>
                <Column dataField="omDetailReference1" visible={false} caption="Reference-1 OMDetail"></Column>
                <Column dataField="omDetailReference2" visible={false} caption="Reference-2 OMDetail"></Column>
                <Column dataField="omDetailReference3" visible={false} caption="Reference-3 OMDetail"></Column>
                <Column dataField="omDetailReference4" visible={false} caption="Reference-4 OMDetail"></Column>
                <Column dataField="omDetailReference5" visible={false} caption="Reference-5 OMDetail"></Column>
                <Column dataField="omDetailReference6" visible={false} caption="Reference-6 OMDetail"></Column>
                <Column dataField="omDetailReference7" visible={false} caption="Reference-7 OMDetail"></Column>
                <Column dataField="omDetailReference8" visible={false} caption="Reference-8 OMDetail"></Column>
                <Column dataField="omDetailReference9" visible={false} caption="Reference-9 OMDetail"></Column>
                <Column dataField="omDetailReference10" visible={false} caption="Reference-10 OMDetail"></Column>
                <Column dataField="transactionNumber" visible={false} caption="Transaction Number"></Column>
                <Column dataField="headerShippingDate" visible={false} caption="Header Shipping Date"></Column>
                <Column dataField="customerID" visible={false} caption="Customer"></Column>
                <Column dataField="customerName" visible={false} caption="Customer Name"></Column>
                <Column dataField="discountedPrice" visible={false} format={{
                    type: 'fixedPoint',
                    precision: 2
                }} caption="Discounted Price"></Column>
                <Column dataField="code1Lot" visible={false} caption="Code-1 Lot"></Column>
                <Column dataField="code2Lot" visible={false} caption="Code-2 Lot"></Column>
                <Column dataField="code3Lot" visible={false} caption="Code-3 Lot"></Column>
                <Column dataField="code4Lot" visible={false} caption="Code-4 Lot"></Column>
                <Column dataField="code5Lot" visible={false} caption="Code-5 Lot"></Column>
                <Column dataField="code6Lot" visible={false} caption="Code-6 Lot"></Column>
                <Column dataField="code7Lot" visible={false} caption="Code-7 Lot"></Column>
                <Column dataField="code8Lot" visible={false} caption="Code-8 Lot"></Column>
                <Column dataField="code9Lot" visible={false} caption="Code-9 Lot"></Column>
                <Column dataField="code10Lot" visible={false} caption="Code-10 Lot"></Column>
                <Column dataField="date1Lot" visible={false} caption="Date-1 Lot" dataType="date" format="MM/dd/yyyy"></Column>
                <Column dataField="date2Lot" visible={false} caption="Date-2 Lot" dataType="date" format="MM/dd/yyyy"></Column>
                <Column dataField="date3Lot" visible={false} caption="Date-3 Lot" dataType="date" format="MM/dd/yyyy"></Column>
                <Column dataField="date4Lot" visible={false} caption="Date-4 Lot" dataType="date" format="MM/dd/yyyy"></Column>
                <Column dataField="date5Lot" visible={false} caption="Date-5 Lot" dataType="date" format="MM/dd/yyyy"></Column>
                <Column dataField="date6Lot" visible={false} caption="Date-6 Lot" dataType="date" format="MM/dd/yyyy"></Column>
                <Column dataField="date7Lot" visible={false} caption="Date-7 Lot" dataType="date" format="MM/dd/yyyy"></Column>
                <Column dataField="date8Lot" visible={false} caption="Date-8 Lot" dataType="date" format="MM/dd/yyyy"></Column>
                <Column dataField="date9Lot" visible={false} caption="Date-9 Lot" dataType="date" format="MM/dd/yyyy"></Column>
                <Column dataField="date10Lot" visible={false} caption="Date-10 Lot" dataType="date" format="MM/dd/yyyy"></Column>
                <Column dataField="quantity1Lot" visible={false} caption="Quantity-1 Lot"></Column>
                <Column dataField="quantity2Lot" visible={false} caption="Quantity-2 Lot"></Column>
                <Column dataField="quantity3Lot" visible={false} caption="Quantity-3 Lot"></Column>
                <Column dataField="quantity4Lot" visible={false} caption="Quantity-4 Lot"></Column>
                <Column dataField="quantity5Lot" visible={false} caption="Quantity-5 Lot"></Column>
                <Column dataField="quantity6Lot" visible={false} caption="Quantity-6 Lot"></Column>
                <Column dataField="quantity7Lot" visible={false} caption="Quantity-7 Lot"></Column>
                <Column dataField="quantity8Lot" visible={false} caption="Quantity-8 Lot"></Column>
                <Column dataField="quantity9Lot" visible={false} caption="Quantity-9 Lot"></Column>
                <Column dataField="quantity10Lot" visible={false} caption="Quantity-10 Lot"></Column>
                <Column dataField="reference1Lot" visible={false} caption="Reference-1 Lot"></Column>
                <Column dataField="reference2Lot" visible={false} caption="Reference-2 Lot"></Column>
                <Column dataField="reference3Lot" visible={false} caption="Reference-3 Lot"></Column>
                <Column dataField="reference4Lot" visible={false} caption="Reference-4 Lot"></Column>
                <Column dataField="reference5Lot" visible={false} caption="Reference-5 Lot"></Column>
                <Column dataField="reference6Lot" visible={false} caption="Reference-6 Lot"></Column>
                <Column dataField="reference7Lot" visible={false} caption="Reference-7 Lot"></Column>
                <Column dataField="reference8Lot" visible={false} caption="Reference-8 Lot"></Column>
                <Column dataField="reference9Lot" visible={false} caption="Reference-9 Lot"></Column>
                <Column dataField="reference10Lot" visible={false} caption="Reference-10 Lot"></Column>
                <Toolbar>
                <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                 </Item>
                    {props.allowReviewedInventory && (
                        <Item location="after">
                            <GridOptionsButton
                                items={operationDropDownItems}
                                onItemClick={onOperationItemClick}
                                disabled={!selectedDetailRow || running}
                            />
                        </Item>
                    )}
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(OrderDetailResult);